module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/banner_withpet@2x-f45153f968c9e24e2a080506cd828822.webp";